import { MenuItems, Term } from "custom-types/Wordpress";

import Breadcrumb from "components/Breadcrumb";
import Breadcrumbs from "components/Breadcrumbs";
import NewsAdBillboard from "components/news/Ads/NewsAdBillboard";
import NewsAdLower from "components/news/Ads/NewsAdLower";
import ArticleContent from "components/news/ArticleContent";
import GlossaryNavigation from "components/news/GlossaryNavigation";
import NewsFeaturedMedia from "components/news/NewsFeaturedMedia";
import NewsRequiredContainer from "components/news/NewsRequiredContainer";
import NewsSideBar from "components/news/NewsSideBar";
import NewsSocialShareBar from "components/news/NewsSocialShareBar";

type Props = {
  menuItems: MenuItems;
  term: Term;
  currentLetter: string;
};

const CannabisGlossaryTermLayout: React.FC<Props> = ({
  term,
  menuItems,
  currentLetter,
}) => {
  const {
    disableAds = false,
    styles = [],
    scripts = [],
    schemaJson,
    id,
    regionRestriction = "WW",
    seoHeadContent = "",
    featuredMedia,
    title = "",
    slug,
    link,
  } = term;

  return (
    <NewsRequiredContainer
      styles={styles}
      scripts={scripts}
      id={id}
      regionRestriction={regionRestriction}
      seoHeadContent={seoHeadContent}
      title={title}
      schemaJson={schemaJson}
      slug={slug}
    >
      <Breadcrumbs className="mt-lg">
        <Breadcrumb href="/learn">Leafly Learn</Breadcrumb>
        <Breadcrumb href="/learn/cannabis-glossary">
          Cannabis Glossary
        </Breadcrumb>
        <Breadcrumb href={`/learn/cannabis-glossary?letter=${currentLetter}`}>
          {currentLetter === "special" ? "#" : currentLetter.toUpperCase()}
        </Breadcrumb>
        <Breadcrumb
          href={`/learn/cannabis-glossary/${slug}`}
          currentLocation={true}
        >
          {title}
        </Breadcrumb>
      </Breadcrumbs>
      {!disableAds && <NewsAdBillboard />}
      <div className="container mb-section mt-sm relative">
        <GlossaryNavigation currentLetter={currentLetter} />
        <div className="row">
          <div className="col md:col-3">
            <NewsSideBar
              menuItems={menuItems}
              disableAds={disableAds}
              optionLabel="Select a term"
            />
          </div>
          <div className="col md:col-9">
            <div className="md:flex items-center justify-between mb-md">
              <h1 className="mb-sm md:mb-none">{title}</h1>
              <NewsSocialShareBar link={link} title={title} />
            </div>
            <NewsFeaturedMedia media={featuredMedia} />
            <ArticleContent item={term} className="mt-lg" />
            {!disableAds && <NewsAdLower />}
          </div>
        </div>
      </div>
    </NewsRequiredContainer>
  );
};

export default CannabisGlossaryTermLayout;
